import React from "react";
import PropTypes from 'prop-types';
import { Row, Col, Container } from 'react-bootstrap';
import { Card, SvgIcon } from "@material-ui/core";
import './InsurancePlanFooter.scss';

export default function InsurancePlanFooter({ InsurancePlan, props, classes }) {
    const navigateTo = (link) => {
        if (props.history && link) {
            props.history.push(link);
        }
    };
    return (
        <Container className="insurance-plan">
            <Row className='justify-content-center'><h3 className="mt-4">Complete your insurance plan</h3></Row>
            <Row className="plan-card">
                {InsurancePlan.map((item, index) => {
                    return (
                    <Col key={index} xs={12} md={4} lg={4} sm={12} className="mt-1 p-0">
                        <Card className="insurance-plan-card">
                            <Row className='pl-1'>
                                <Col xs={2} sm={1} md={2} className='main-icon pt-1'>
                                    <SvgIcon component={item.icon} color='primary' viewBox='0 0 30 30' fontSize="large" />
                                </Col>
                                <Col xs={10} sm={11} md={10} className='main-content'>
                                    <span>{item.title}</span>
                                    <div className="plan-content">{item.content}</div>
                                    <button className={`insurance-btn mt-1 ${classes.colorText}`}
                                        onClick={() => navigateTo(item.linkTo)}>
                                        <b className="btn-name">{item.btnTitle}</b>
                                    </button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    );
                })}
            </Row>
        </Container>
    );
};

InsurancePlanFooter.propTypes = {
    InsurancePlan: PropTypes.array,
    classes: PropTypes.object,
    props: PropTypes.object,
    history: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/InsurancePlanFooter/InsurancePlanFooter.js